import {
  CASHOUT_ACTION_SET_ORDER_CASHOUT,
  CASHOUT_ACTION_SET_STATE,
  CASHOUT_ACTION_SET_MAX_ORDER_CASHOUT,
  CASHOUT_ACTION_SET_MIN_ORDER_CASHOUT,
  CASHOUT_ACTION_SET_ORDER_PARTIAL_CASHOUT,
  orderCashoutWarningSmallAmount,
  orderCashoutWarningBigAmount,
  orderPartialCashoutWarningSmallAmount,
  orderPartialCashoutWarningBigAmount,
  orderCashoutTypes
} from './constants'

const { ORDER_PARTIAL_CASHOUT_TYPE } = orderCashoutTypes

const validateOrderCashout = (state) => {
  const {
    orderPartialCashout,
    orderCashout,
    maxOrderCashout,
    minOrderCashout,
    orderCashoutType,
    minPartialCashOut
  } = state
  let orderCashoutWarning = { }

  if (orderCashoutType === ORDER_PARTIAL_CASHOUT_TYPE) {
    if (orderPartialCashout >= orderCashout) {
      orderCashoutWarning = {
        type: orderPartialCashoutWarningBigAmount,
        amount: orderCashout - 1
      }
    }
    if (!orderPartialCashout || orderPartialCashout < minPartialCashOut) {
      orderCashoutWarning = {
        type: orderPartialCashoutWarningSmallAmount,
        amount: minPartialCashOut
      }
    }
  }
  if (orderCashout > maxOrderCashout) {
    orderCashoutWarning = {
      type: orderCashoutWarningBigAmount,
      amount: maxOrderCashout
    }
  } else if (orderCashout < minOrderCashout) {
    orderCashoutWarning = {
      type: orderCashoutWarningSmallAmount,
      amount: minOrderCashout
    }
  }

  return {
    ...state,
    orderCashoutWarning
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case CASHOUT_ACTION_SET_STATE: {
      const updatedState = action.payload
      const { estimatedCashOut } = updatedState
      if (estimatedCashOut) {
        const amount = updatedState.amount ? updatedState.amount : state.amount
        // min order cashout value depend on estimated cashout
        updatedState.minOrderCashout = amount < estimatedCashOut ? estimatedCashOut + 1 : amount
      }

      return {
        ...state,
        ...updatedState
      }
    }

    case CASHOUT_ACTION_SET_MAX_ORDER_CASHOUT: {
      const { maxOrderCashout } = state
      const orderCashout = maxOrderCashout

      return {
        ...state,
        orderCashout
      }
    }

    case CASHOUT_ACTION_SET_MIN_ORDER_CASHOUT: {
      const { minOrderCashout } = state
      const orderCashout = minOrderCashout

      return {
        ...state,
        orderCashout
      }
    }

    case CASHOUT_ACTION_SET_ORDER_CASHOUT: {
      const orderCashout = action.payload

      return validateOrderCashout({
        ...state,
        orderCashout
      })
    }

    case CASHOUT_ACTION_SET_ORDER_PARTIAL_CASHOUT : {
      const orderPartialCashout = action.payload

      return validateOrderCashout({
        ...state,
        orderPartialCashout
      })
    }

    default:
      return state
  }
}
